import { Breadcrumb } from 'react-bootstrap';
import styled from 'styled-components';
import theme from 'styles/theme';

export const BreadcrumbStyled = styled(Breadcrumb)`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  padding: 0;

  & > li {
    align-items: center;
    display: flex;
    height: 40px;
    position: relative;

    &:not(:last-of-type) {
      padding-right: 10px;
    }

    &.active > span:last-child {
      color: ${theme.colors.fontGreen};
    }
  }

  & > li + li {
    margin-left: 15px;
  }

  & > li + li:before {
    content: '>';
    position: absolute;
    top: 50%;
    left: -12px;
    transform: translate(-50%, -50%);
  }

  & > li:has(.form-field-container) {
    flex: 1;
    max-width: 233px;
    min-width: 120px;
  }

  .form-field-container {
    display: inline-block;
    margin: 2px 0 0 0;
  }
`;
